import React from "react";
import { Link } from "react-router-dom";
import "../styles/PrivacyPolicy.css";

const Section = ({ id, title, children }) => (
  <section id={id} className="pp-section">
    {title && <h2 className="pp-h2">{title}</h2>}
    {children}
  </section>
);

const CookieCard = ({ title, type, admin, purpose }) => (
  <div className="pp-cookie-card">
    <div className="pp-cookie-title">{title}</div>
    <div className="pp-cookie-row"><span>Type</span><b>{type}</b></div>
    <div className="pp-cookie-row"><span>Administered by</span><b>{admin}</b></div>
    {purpose && <div className="pp-cookie-row"><span>Purpose</span><b>{purpose}</b></div>}
  </div>
);

/**
 * Static Cookie Policy page -- a fuller standalone treatment of the cookie
 * section already summarized in PrivacyPolicy.js.
 */
export default function CookiePolicy() {
  return (
    <div className="pp-page">
      <div className="pp-container">

        <div className="pp-hero">
          <div className="pp-hero-badge">Legal</div>
          <h1 className="pp-h1">Cookie Policy</h1>
          <p className="pp-last-updated">Last updated: July 31, 2026</p>
          <p className="pp-intro">
            This Cookie Policy explains what cookies are, how One Global
            Marketplace ("OGM", "We") uses them, and the choices You have. It
            should be read alongside our <Link to="/privacy-policy">Privacy Policy</Link>.
          </p>
        </div>

        <Section title="What Are Cookies?">
          <p>
            Cookies are small text files placed on Your device when You visit a
            website. They let a site remember information about Your visit —
            such as Your preferred language or whether You're signed in — to
            make Your next visit easier and the site more useful to You.
          </p>
        </Section>

        <Section title="Types of Cookies We Use">
          <div className="pp-cookie-grid">
            <CookieCard
              title="Strictly Necessary"
              type="Session"
              admin="Us"
              purpose="Required for core functionality -- signing in, keeping your session active, and basic security. The Service cannot function properly without these."
            />
            <CookieCard
              title="Preference / Functionality"
              type="Persistent"
              admin="Us"
              purpose="Remember choices like theme, recently viewed properties, and saved favorites."
            />
            <CookieCard
              title="Analytics"
              type="Persistent"
              admin="Us / Third parties"
              purpose="Help Us understand how visitors use the Service, so We can improve it."
            />
          </div>
        </Section>

        <Section title="Third-Party Cookies">
          <p>
            Some features on the Service are provided by third parties who may
            set their own cookies when You interact with them, including:
          </p>
          <ul className="pp-list">
            <li><strong>Google Maps</strong> -- for property location, directions, and nearby places</li>
            <li><strong>Google Sign-In</strong> -- for broker/user authentication</li>
            <li><strong>WhatsApp Business</strong> -- for the WhatsApp contact and registration widgets</li>
            <li><strong>Firebase</strong> -- for underlying app infrastructure</li>
          </ul>
          <p>
            We do not control these third-party cookies. Please review each
            provider's own cookie/privacy policy for details.
          </p>
        </Section>

        <Section title="Managing or Disabling Cookies">
          <p>
            Most browsers let You see what cookies are stored and delete them
            individually, block third-party cookies, or block all cookies from
            specific sites. Since every browser is different, check Your
            browser's Help menu for the exact steps. Note that blocking
            strictly necessary cookies may prevent parts of the Service (such
            as staying signed in) from working correctly.
          </p>
        </Section>

        <Section title="Changes to This Cookie Policy">
          <p>
            We may update this Cookie Policy from time to time. Changes will be
            reflected by updating the "Last updated" date above.
          </p>
        </Section>

        <div className="pp-contact">
          <div className="pp-contact-icon">🍪</div>
          <h2 className="pp-h2" style={{ marginBottom: 8 }}>Questions?</h2>
          <p style={{ margin: "0 0 16px" }}>
            If you have questions about how We use cookies, reach out any time:
          </p>
          <Link to="/contact" className="pp-contact-link">
            Visit our Contact Page →
          </Link>
        </div>

      </div>
    </div>
  );
}
